const MillisecondsToDay = (ms: number | string) => (+ms / 1000 / 60 / 60 / 24)

export default MillisecondsToDay